import { getPostApi } from "../../callApi/postApi";
import CustomBottom from "../../components/CustomBottom";
import CustomButton from "../../components/CustomButton";
import CustomHeader from "../../components/CustomHeader";
import { format } from "date-fns";
// import { useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const router = useNavigate();
  const [nowPage, setnowPage] = useState(1);
  const [allPage, setallPage] = useState(1);
  const [contentData, setcontentData] = useState(null);
  useEffect(() => {
    if (nowPage) {
      getContent();
    }
  }, [nowPage]);
  const getContent = async () => {
    const res = await getPostApi({
      limit: 6,
      page: nowPage,
      post_categories_id: 1,
    });
    if (res?.status == 200) {
      let temp = [...res.data.data.post];
      for (let i = 0; i < res.data.data.post.length; i++) {
        if (res.data.data.post[i]?.content) {
          temp[i].content_json = JSON.parse(res.data.data.post[i]?.content);
          let FirstImg = null;
          let FirstText = null;
          for (let j = 0; j < temp[i].content_json?.html?.length; j++) {
            for (let k = 0; k < temp[i].content_json?.html[j].length; k++) {
              if (
                FirstImg == null &&
                temp[i].content_json.html[j][k].type == "image"
              ) {
                FirstImg = temp[i].content_json?.html[j][k].value;
              } else if (
                FirstText == null &&
                temp[i].content_json.html[j][k].type == "text"
              ) {
                FirstText = temp[i].content_json?.html[j][k].value;
              }
              if (FirstImg != null && FirstText != null) {
                break;
              }
            }
            if (FirstImg != null && FirstText != null) {
              break;
            }
          }
          temp[i].content_json.img = FirstImg;
          temp[i].content_json.text = FirstText;
        }
      }
      console.log("temp", temp);
      setcontentData(temp ?? []);
      setallPage(Math.ceil(res?.data?.data?.count / 4));
    }
  };
  const CeoSection = () => {
    return (
      <div className="bg-white py-[60px] flex flex-col gap-[40px] ">
        <div
          className="flex flex-row items-center gap-4 max-w-[1580px] mx-auto"
          style={{ justifyContent: "center" }}
        >
          <div className="w-5 h-5 bg-[#B36427]" />
          <div
            className="font_Kanit font-semibold"
            style={{ fontSize: "36px" }}
          >
            เกี่ยวกับโครงการ
          </div>
          <div className="w-5 h-5 bg-[#B36427]" />
        </div>
        <div
          className="flex flex-col px-5 md:flex-row items-center gap-[40px] max-w-[1580px] mx-auto"
          style={{ justifyContent: "center" }}
        >
          <img src="/img/ceo.png" className="w-[200px] object-contain" />
          <div>
            <div className="font_Kanit font-bold text-[36px]">
              ผศ.ดร.ธีระยุทธ์ เพ็งชัย
            </div>
            <div className="font_Kanit text-lg">
              ศูนย์ออกแบบสร้างสรรค์ผ้าและสิ่งทอ มหาวิทยาลัยราชภัฏอุดรธานี หรือ
              FTCDC (Fabric and Textile Creative Design Center)
              มีพันธกิจในการอนุรักษ์เชิงพัฒนา
              และยกระดับผ้าและสิ่งทอในชุมชนสู่ความเป็นสากล
              ด้วยการบูรณาการภูมิปัญญา
              ศิลปะงานฝีมือดั้งเดิมในวัฒนธรรมการทอผ้าของชุมชนอีสาน
              กับการพัฒนาด้วยนวัตกรรม เทคโนโลยีและการสร้างสรรค์ ตั้งแต่ต้นน้ำ
              กลางน้ำ ปลายน้ำ เพื่อให้ผ้าและสิ่งทอชุมชนอยู่ได้อย่างยั่งยืน
            </div>
          </div>
          <img src="/img/ceo sign.png" className="w-[500px] object-contain" />
        </div>
      </div>
    );
  };
  const NewsSection = () => {
    return (
      <div className="pt-[40px]">
        <div
          className="flex flex-row items-center gap-4 max-w-[1580px] mx-auto"
          style={{ justifyContent: "center" }}
        >
          <div className="w-5 h-5 bg-[#B36427]" />
          <div
            className="font_Kanit font-semibold"
            style={{ fontSize: "36px" }}
          >
            ข่าวและกิจกรรม
          </div>
          <div className="w-5 h-5 bg-[#B36427]" />
        </div>
        <div className="bg-[#B36427] px-[40px] py-[40px] flex flex-col gap-10">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 max-w-[1280px] gap-[40px] mx-auto">
            {contentData?.map((item, i) => {
              return (
                <div
                  key={i}
                  className="flex flex-col gap-5 w-[300px] md:w-[400px] h-[669px] rounded-lg drop-shadow-md bg-white items-center pb-[20px]"
                >
                  <img
                    src={
                      item?.content_json.img
                        ? "https://ftcdc.udru.ac.th/ftcdc-api/storage/app/public/upload/UploadImg/" +
                          item?.content_json.img
                        : "/img/logo.png"
                    }
                    className="object-cover h-[300px] w-full rounded-t-lg"
                  />
                  <div className="flex flex-col gap-2 px-5 flex-[1] w-full">
                    <div className="font_Kanit text-[24px] font-bold line-clamp-3">
                      {item.title}
                    </div>
                    <div className="font_Kanit line-clamp-5 text-base font-medium">
                      {item?.content_json?.text != null ? (
                        <div>{parse(item?.content_json?.text)}</div>
                      ) : (
                        <p></p>
                      )}
                    </div>
                    <div className="font_Kanit text-center text-[#858485] text-sm ">
                      {format(new Date(item.updated_at), "MMMM dd,yyy")} By
                      Admin
                    </div>
                  </div>
                  <CustomButton
                    txt={"อ่านเพิ่มเติม"}
                    classAdditional="font_Kanit font-semibold text-lg "
                    onClick={() => {
                      router.push("/blog/" + item.id);
                      setTimeout(function () {
                        document.documentElement.style.scrollBehavior = "smooth";
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                      }, 500);
                    }}
                  />
                </div>
              );
            })}
          </div>
          <CustomButton
            onClick={() => {
              router.push("/blog");
              setTimeout(function () {
                document.documentElement.style.scrollBehavior = "smooth";
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
              }, 500);
            }}
            txt={"อ่านเพิ่มเติม"}
            bgcolor="#F89343"
            classAdditional="font_Kanit font-semibold text-lg self-center w-[200px] text-center"
          />
        </div>
      </div>
    );
  };
  return (
    <div className="fade_In_up">
      <CustomHeader />
      <img
        src="/img/bghome1.png"
        className="w-[43vw] absolute top-[200px] right-0 -z-[5] "
      />
      <img
        src="/img/bghome2.png"
        className="w-[10vw] absolute top-[200px] left-[14vw] -z-[5] hidden md:flex "
      />
      <div className="flex flex-col items-center pt-[230px]">
        <div className="font_Kanit font-medium text-[130px] lg:text-[250px] lg:leading-[350px] ">
          FTCDC
        </div>
        <div className="font_Kanit font-medium text-[20px] lg:text-[45px] ">
          Fabric & Textiles Creative Design Center
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 w-full p-[32px] mt-7 ">
        <img src="/img/home1.jpg" className="object-contain w-full " />
        <div className="md:col-span-2 flex flex-col items-start gap-[30px] ">
          <div className="font_Kanit font-bold text-[36px]">เกี่ยวกับเรา</div>
          <div className="font_Kanit text-[18px]">
            ศูนย์การออกเเบบสร้างสรรค์ผ้าเเละสิ่งทอ มหาวิทยาลัยราชภัฏอุดรธานี
            หรือ FTCDC : Fabric and Texile Creative Design Center
            จัดตั้งขึ้นเพื่อสนับสนุนในพันธกิจของการเป็นสถาบันอุดมศึกษา
            เพื่อการพัฒนาท้องถิ่นโดยเฉพาะ กลุ่มจังหวัดในภาคตะวันออกเฉียงเหนือ
            ซึ่งภูมิวัฒนธรรมที่คล้ายคลึกกันโดยเฉพาะด้านการทอผ้า
            โดยการทอผ้าพื้นเมืองของประชาชนเป็นกลไกสะท้อนถึงวิถีในการดำรงชีวิตมานาน
            ดังนั้นวัตถุประสงค์ของศูนย์การออกเเบบสร้างสรรค์ผ้าเเละสิ่งทอ
            จึงเป็นการเข้าไปศึกษา สร้างสรรค์
            พัฒนาร่วมกับชุมชนทอผ้าพื้นเมืองตั้งเเต่ต้นน้ำ กลางน้ำ
            เเละปลายน้ำเพื่อให้วิถีการทอผ้าพื้นเมืองยังคงอยู่ให้ลูกหลานได้ศึกษา
            เเละยังเป็นส่วนสร้างอาชีพ สร้างรายได้ให้กับกลุ่มชุมชนอย่างยั่งยืน
          </div>
          <CustomButton
            txt={"อ่านเพิ่มเติม"}
            classAdditional="font_Kanit font-semibold"
            onClick={() => {
              router("/about");
              setTimeout(function () {
                document.documentElement.style.scrollBehavior = "smooth";
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
              }, 500);
            }}
          />
          <div className="font_Kanit font-bold text-[36px] mt-[30px]">
            พิพิธภัณฑ์ผ้าอีสาน
            <br />
            ISAN Museum Of Textiles
          </div>
          <div className="font_Kanit text-[18px]">
            การสร้างพิพิธภัณฑ์ผ้าทอพื้นเมืองอีสานและแหล่งเรียนรู้ เพื่ออนุรักษ์
            และการเผยแพร่วัฒนธรรม ภูมิปัญญา องค์ความรู้ผ้าทอพื้นเมือง
            เนื่องจากจังหวัดอุดรธานีและจังหวัดใกล้เคียงยังไม่มีพิพิธภัณฑ์ผ้าทอพื้นเมือง
            ประกอบกับเป็นหมุดหมายที่สำคัญของการเป็นเมือง “ธานีผ้าหมี่ขิด”
            และยังเป็นแหล่งเรียนรู้แหล่งท่องเที่ยวเชิงวัฒนธรรมด้านการทอผ้าพื้นเมือง
            ตั้งแต่ต้นน้ำ กลางน้ำและปลายน้ำ แห่งแรกในภาคตะวันออกเฉียงเหนือ
            รวมถึงศึกษาวิจัยนวัตกรรมเส้นใยและสีย้อมจากธรรมชาติ
            การเผยแพร่องค์ความรู้วัฒนธรรมภูมิปัญญาและองค์ความรู้ผ้าทอพื้นเมืองอีกด้วย{" "}
          </div>
          <CustomButton
            txt={"อ่านเพิ่มเติม"}
            classAdditional="font_Kanit font-semibold"
            onClick={() => {
              router("/museum");
              setTimeout(function () {
                document.documentElement.style.scrollBehavior = "smooth";
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
              }, 500);
            }}
          />
          <iframe
            src="https://www.youtube.com/embed/ldb3_GZutzk?si=kELIlwQMn-gw8WKs"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowFullScreen
            className="w-[308px] h-[173.25px] md:w-[560px] md:h-[315px] self-center"
          ></iframe>
        </div>
      </div>
      <div className=" p-[32px] mt-[30px] flex flex-col items-center mb-[60px]">
        <div className="font_Kanit font-bold text-[36px] text-left w-full">
          ศูนย์ทดสอบสิ่งทอ
        </div>
        <div className="font_Kanit text-[18px] mt-[24px] mb-[30px] text-left w-full">
          Fabric and Textile Analytical Testing Laboratory (FTCDC LAB) <br />
          ห้องปฏิบัติการทดสอบวิเคราะห์ผ้าและสิ่งทอ
          ศูนย์ออกกแบบสร้างสรรค์ผ้าและสิ่งทอ (FTCDC) มหาวิทยาลัยราชภัฏอุดรธานี{" "}
          <br />
          - เครื่องมือทดสอบตามมาตรฐาน ISO, AATCC เครื่องทดสอบ SDL Atlas
          จากสหรัฐอเมริกา เครื่องมือเฉพาะสำหรับทดสอบสิ่งทอ
          เพื่อพัฒนาคุณภาพสิ่งทอพื้นเมืองให้มีประสิทธิภาพและยั่งยืน <br />-
          พัฒนาศักยภาพ เพิ่มขีดความสามารถแก่สิ่งทอพื้นเมืองแก่ชุมชนท้องถิ่น
          สำหรับมาตรฐานมผช. มอก. และมาตรฐาน Circular design
          พร้อมให้คำปรึกษาครบวงจร
        </div>
        <CustomButton
          txt={"Textile Lab"}
          classAdditional="font_Kanit font-semibold"
          onClick={() => {}}
        />
      </div>
      <div className="flex flex-col items-center bg-[#858485]">
        <div className="flex flex-row justify-end items-center gap-6 self-end p-8">
          <div className="font_Kanit font-bold text-white">ดูทั้งหมดได้ที่</div>
          <CustomButton
            txt={"Design shop"}
            classAdditional="font_Kanit font-semibold"
            onClick={() => {}}
          />
        </div>
        <ScrollContainer
          className={
            "flex flex-row gap-7 pl-5 pr-5 pt-2 pb-20 overflow-x-scroll "
          }
        >
          <img
            src="/img/F-Design01.png"
            className="w-[320px] object-contain "
          />

          <img
            src="/img/F-Design02.png"
            className="w-[320px] object-contain "
          />
          <img
            src="/img/F-Design03.png"
            className="w-[320px] object-contain "
          />
          <img
            src="/img/F-Design04.png"
            className="w-[320px] object-contain "
          />
          <img
            src="/img/F-Design05.png"
            className="w-[320px] object-contain "
          />
        </ScrollContainer>
      </div>
      <CeoSection />
      <NewsSection />
      <CustomBottom />
    </div>
  );
}
